"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InnerTextarea = exports.StatusIndicator = exports.IconWrap = exports.InputWrapper = exports.InnerInput = exports.Error = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _transitions = require("../../utils/transitions");

var _borderRadius = require("../../utils/borderRadius");

var _placeholder = _interopRequireDefault(require("../../utils/placeholder"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n      color: ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    color: ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var inputBorderColor = function inputBorderColor(props) {
  var active = props.active,
      theme = props.theme,
      disabled = props.disabled;

  if (active) {
    return theme.color.primary;
  } else if (disabled) {
    return theme.color.miscLighter;
  }

  return theme.color.misc;
};

var TEXTAREA_PADDINGS = {
  large: 10,
  normal: 8,
  small: 5
};
var ICON_PADDINGS = {
  large: {
    outer: '10px',
    inner: '8px'
  },
  normal: {
    outer: '7px',
    inner: '5px'
  },
  small: {
    outer: '7px',
    inner: '5px'
  }
};
var ICON_GROUP_PADDINGS = {
  large: {
    outer: '10px',
    inner: '3px'
  },
  normal: {
    outer: '7px',
    inner: '3px'
  },
  small: {
    outer: '7px',
    inner: '3px'
  }
};
var SIZE = {
  large: 14,
  normal: 11,
  small: 8
};
var TYPOGRAPHY = {
  large: 18,
  normal: 16,
  small: 16
};
var INPUTHEIGHT = {
  large: '42px',
  normal: '36px',
  small: '30px'
};

var displayIndicator = function displayIndicator(_ref) {
  var active = _ref.active,
      success = _ref.success,
      error = _ref.error;

  if (active) {
    return 'none';
  }

  if (success || error) {
    return 'block';
  }

  return 'none';
};

var Error = _styledComponents["default"].span.withConfig({
  displayName: "styled__Error",
  componentId: "cs0mfm-0"
})(["position:absolute;top:calc(100% + 2px);left:0;display:flex;align-items:center;padding:3px 12px 5px;font-size:14px;line-height:16px;color:#fff;opacity:0.97;z-index:2;", " background-color:", ";"], _borderRadius.borderRadiusSmall.all, function (_ref2) {
  var theme = _ref2.theme;
  return theme.color.fail;
});
/* eslint-disable react/prop-types */


exports.Error = Error;

var InnerInput = _styledComponents["default"].input.withConfig({
  displayName: "styled__InnerInput",
  componentId: "cs0mfm-1"
})(["position:relative;flex-grow:1;flex-shrink:1;width:100%;height:100%;line-height:normal;border:none;min-height:", ";font-family:inherit;", ";padding-left:", ";padding-right:", ";font-size:", "px;color:", ";background-color:transparent;", " ", " ", " &:focus{outline-style:none;}&:disabled{", "}"], function (_ref3) {
  var size = _ref3.size;
  return INPUTHEIGHT[size];
}, function (_ref4) {
  var size = _ref4.size;
  return size === 'large' ? 'letter-spacing: -0.1px' : null;
}, function (_ref5) {
  var size = _ref5.size,
      leftIcon = _ref5.leftIcon;
  return leftIcon ? '0' : "".concat(SIZE[size], "px");
}, function (_ref6) {
  var size = _ref6.size,
      rightIcon = _ref6.rightIcon;
  return rightIcon ? '0' : "".concat(SIZE[size], "px");
}, function (_ref7) {
  var size = _ref7.size;
  return TYPOGRAPHY[size];
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.color.textDarker;
}, function (_ref9) {
  var neighboringInGroup = _ref9.neighboringInGroup,
      disabled = _ref9.disabled,
      hasInnerGroup = _ref9.hasInnerGroup,
      theme = _ref9.theme;

  if (hasInnerGroup && ['right', 'both'].includes(neighboringInGroup)) {
    return "border-right: 1px solid ".concat(disabled ? theme.color.miscLightest : theme.color.misc, ";");
  }
}, function (_ref10) {
  var neighboringInGroup = _ref10.neighboringInGroup,
      success = _ref10.success,
      error = _ref10.error;

  if (neighboringInGroup === 'right') {
    return _borderRadius.borderRadiusSmall.left;
  } else if (neighboringInGroup === 'left' || success || error) {
    return _borderRadius.borderRadiusSmall.right;
  } else if (neighboringInGroup !== 'both') {
    return _borderRadius.borderRadiusSmall.all;
  }

  return '';
}, (0, _placeholder["default"])(_templateObject(), function (_ref11) {
  var theme = _ref11.theme;
  return theme.color.miscDark;
}), (0, _placeholder["default"])(_templateObject2(), function (_ref12) {
  var theme = _ref12.theme;
  return theme.color.misc;
}));

exports.InnerInput = InnerInput;
var InnerTextarea = (0, _styledComponents["default"])(InnerInput.withComponent('textarea')).withConfig({
  displayName: "styled__InnerTextarea",
  componentId: "cs0mfm-2"
})(["", ""], function (_ref13) {
  var size = _ref13.size;
  return "\n      padding-top: ".concat(TEXTAREA_PADDINGS[size], "px;\n      padding-bottom: ").concat(TEXTAREA_PADDINGS[size], "px;\n    ");
});
exports.InnerTextarea = InnerTextarea;

var InputWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styled__InputWrapper",
  componentId: "cs0mfm-3"
})(["position:relative;display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:center;background-color:", ";", " ", " border:1px solid ", ";border-style:solid;", " ", " ", " ", " transition-property:border-color;&:hover{border-color:", ";z-index:1;}.combined-inputs-group{height:100%;}"], function (_ref14) {
  var disabled = _ref14.disabled,
      theme = _ref14.theme;
  return disabled ? theme.color.miscLightest : theme.color.background;
}, function (_ref15) {
  var disabled = _ref15.disabled;
  return disabled && 'pointer-events: none;';
}, function (_ref16) {
  var neighboringInGroup = _ref16.neighboringInGroup,
      success = _ref16.success,
      error = _ref16.error;

  if (neighboringInGroup === 'right') {
    return _borderRadius.borderRadiusSmall.left;
  } else if (neighboringInGroup === 'left' || success || error) {
    return _borderRadius.borderRadiusSmall.right;
  } else if (neighboringInGroup !== 'both') {
    return _borderRadius.borderRadiusSmall.all;
  }

  return '';
}, inputBorderColor, function (_ref17) {
  var active = _ref17.active,
      theme = _ref17.theme;

  if (active) {
    return "box-shadow: 0 0 0 1px ".concat(theme.color.primary, ";");
  }
}, function (_ref18) {
  var neighboringInGroup = _ref18.neighboringInGroup;

  if (['left', 'both'].includes(neighboringInGroup)) {
    return 'margin-left: -1px;';
  }
}, function (_ref19) {
  var active = _ref19.active,
      neighboringInGroup = _ref19.neighboringInGroup;
  return active && neighboringInGroup ? 'z-index: 2;' : null;
}, _transitions.switchTransition, function (_ref20) {
  var theme = _ref20.theme,
      disabled = _ref20.disabled;
  return !disabled && theme.color.primary;
});

exports.InputWrapper = InputWrapper;

var StatusIndicator = _styledComponents["default"].div.withConfig({
  displayName: "styled__StatusIndicator",
  componentId: "cs0mfm-4"
})(["position:absolute;top:-1px;left:-1px;display:", ";height:calc(100% + 2px);width:2px;background-color:", ";"], function (props) {
  return displayIndicator(props);
}, function (_ref21) {
  var theme = _ref21.theme,
      success = _ref21.success,
      error = _ref21.error;
  return success && !error ? theme.color.success : theme.color.fail;
});

exports.StatusIndicator = StatusIndicator;

var getIconWrapPaddings = function getIconWrapPaddings(_ref22) {
  var left = _ref22.left,
      right = _ref22.right,
      isGroup = _ref22.isGroup,
      size = _ref22.size;

  if (left && isGroup) {
    return "\n      padding-left: ".concat(ICON_GROUP_PADDINGS[size].outer, ";\n      padding-right: ").concat(ICON_GROUP_PADDINGS[size].inner, ";\n    ");
  } else if (left) {
    return "\n      padding-left: ".concat(ICON_PADDINGS[size].outer, ";\n      padding-right: ").concat(ICON_PADDINGS[size].inner, ";\n    ");
  } else if (right && isGroup) {
    return "\n      padding-left: ".concat(ICON_GROUP_PADDINGS[size].inner, ";\n      padding-right: ").concat(ICON_GROUP_PADDINGS[size].outer, ";\n    ");
  } else if (right) {
    return "\n      padding-left: ".concat(ICON_PADDINGS[size].inner, ";\n      padding-right: ").concat(ICON_PADDINGS[size].outer, ";\n    ");
  }
};

var IconWrap = _styledComponents["default"].div.withConfig({
  displayName: "styled__IconWrap",
  componentId: "cs0mfm-5"
})(["flex-grow:0;flex-shrink:0;height:100%;", " display:flex;vertical-align:top;align-items:center;"], getIconWrapPaddings);

exports.IconWrap = IconWrap;